import { render } from "./InputWrapper.vue?vue&type=template&id=7e0cbdfc"
import script from "./InputWrapper.vue?vue&type=script&lang=js"
export * from "./InputWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script